import React from 'react';
import { Globe, Server, Code } from 'lucide-react';
import { Card } from './ui/card';

const iconMap = {
  Globe: Globe,
  Server: Server,
  Code: Code
};

export const Services = ({ translations, isDark }) => {
  return (
    <section id="services" className={`min-h-screen py-24 transition-colors duration-300 ${
      isDark ? 'bg-zinc-950' : 'bg-white'
    }`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="space-y-16">
          <div className="space-y-4">
            <div className={`inline-block border-2 px-4 py-2 ${
              isDark ? 'border-cyan-400' : 'border-cyan-500'
            }`}>
              <span className={`text-sm uppercase tracking-widest font-mono ${
                isDark ? 'text-cyan-400' : 'text-cyan-600'
              }`}>Services</span>
            </div>
            <h2 className={`text-6xl md:text-7xl font-black leading-none tracking-tighter ${
              isDark ? 'text-white' : 'text-zinc-900'
            }`}>
              {translations.services.title}
            </h2>
            <div className={`h-1 w-24 ${isDark ? 'bg-cyan-400' : 'bg-cyan-500'}`}></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {translations.services.items.map((service, index) => {
              const IconComponent = iconMap[service.icon] || Code;
              return (
                <Card
                  key={service.id}
                  className={`border-2 p-8 transition-all duration-300 group ${
                    isDark 
                      ? 'bg-zinc-900 border-zinc-800 hover:border-cyan-400'
                      : 'bg-zinc-50 border-zinc-200 hover:border-cyan-500'
                  }`}
                >
                  <div className="space-y-6">
                    <div className={`w-16 h-16 border-2 flex items-center justify-center transition-colors duration-300 ${
                      isDark 
                        ? 'bg-cyan-400/10 border-cyan-400 group-hover:bg-cyan-400'
                        : 'bg-cyan-500/10 border-cyan-500 group-hover:bg-cyan-500'
                    }`}>
                      <IconComponent className={`w-8 h-8 transition-colors duration-300 ${
                        isDark
                          ? 'text-cyan-400 group-hover:text-black'
                          : 'text-cyan-600 group-hover:text-white'
                      }`} />
                    </div>
                    
                    <div className="space-y-3">
                      <h3 className={`text-2xl font-bold uppercase tracking-tight ${
                        isDark ? 'text-white' : 'text-zinc-900'
                      }`}>
                        {service.title}
                      </h3>
                      <p className={`leading-relaxed ${
                        isDark ? 'text-zinc-400' : 'text-zinc-600'
                      }`}>
                        {service.description}
                      </p>
                    </div>

                    <div className="pt-4">
                      <div className={`inline-block font-mono text-sm group-hover:translate-x-2 transition-transform duration-300 ${
                        isDark ? 'text-cyan-400' : 'text-cyan-600'
                      }`}>
                        [{String(index + 1).padStart(2, '0')}]
                      </div>
                    </div>
                  </div>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};